import { memo } from 'react';
import { Document } from 'models';
import { format } from 'date-fns';
import { toDate } from 'utils';

import { Loader, NoData, Centered } from 'components';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import { useStyles } from './style';

interface DocumentLoading {
  DeleteLoading: boolean;
  DownloadLoading: boolean;
}

interface Props {
  downloadFile: (id: string, name: string) => void;
  documents: Array<Document & DocumentLoading>;
  handleDelete: (id: string) => void;
}

const ServerFileList: React.FC<Props> = ({
  downloadFile,
  documents,
  handleDelete,
}) => {
  const classes = useStyles();

  if (!documents.length) {
    return (
      <Centered>
        <NoData text={'FilesAreNotAttached'} />
      </Centered>
    );
  }

  return (
    <ul className={classes.ul}>
      {documents.map((document) => {
        let createdOn = toDate(document.CreatedOn);

        return (
          <li className={classes.li}>
            <div className={classes.leveler}>
              {document.DownloadLoading ? (
                <div className={classes.marginRight}>
                  <Loader size={15} themeColor="darkBlue" />
                </div>
              ) : null}
              <span
                title={'Lataa'}
                className={classes.name}
                onClick={() => downloadFile(document.Id, document.Name)}
              >
                {document.Name}
              </span>
            </div>
            <div className={classes.flex}>
              <span className={classes.size}>
                {createdOn ? format(createdOn, 'd.M.yyyy') : null}
              </span>
              {document.CanDelete ? (
                document.DeleteLoading ? (
                  <div className={classes.loader}>
                    <Loader size={15} themeColor="darkBlue" />
                  </div>
                ) : (
                  <Button
                    onClick={() => handleDelete(document.Id)}
                    classes={{ root: classes.button }}
                    title={'Poista'}
                  >
                    <CloseIcon className={classes.icon} />
                  </Button>
                )
              ) : null}
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default memo(ServerFileList);
